import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { Router } from '@angular/router';
import { BloccoImmobile, StaticUrls, Servizio, BloccoImmobileSearch } from '../models';
import { MyCookieService } from './my-cookie.service';
import { environment } from 'environments/environment';

@Injectable()
export class BloccoImmobileService {
	private blocchi: Array<BloccoImmobile>;
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp,
		private router: Router,
		@Inject(MyCookieService) private myCookieService: MyCookieService) { }

	post(blocco: BloccoImmobile): Observable<Response> {
		if (this.ifTokenNotExpired()) {
			if (this.myCookieService.token) {
				return this.http.post(StaticUrls._bloccoImmobile, JSON.stringify(blocco), this.options)
					.map((response: Response) => {
						return response;
					});
			}
		}
	}

	approva(id: number): Observable<Response> {
		if (this.ifTokenNotExpired()) {
			if (this.myCookieService.token) {
				return this.http.put(StaticUrls._bloccoImmobileApprova, JSON.stringify(id), this.options)
					.map((response: Response) => {
						return response;
					});
			}
		}
	}

	rifiuta(id: number): Observable<Response> {
		if (this.ifTokenNotExpired()) {
			if (this.myCookieService.token) {
				return this.http.put(StaticUrls._bloccoImmobileRifiuta, JSON.stringify(id), this.options)
					.map((response: Response) => {
						return response;
					});
			}
		}
	}

	searchEffettuati(blocco: BloccoImmobileSearch): Observable<Array<BloccoImmobile>> {
		if (this.ifTokenNotExpired()) {
			if (this.myCookieService.token) {
				return this.http.post(StaticUrls._bloccoImmobileSearchEffettuati, JSON.stringify(blocco), this.options)
				.map(this.extractData)
				.catch(this.handleError);
			}
		}
	}

	countSearchEffettuati(blocco: BloccoImmobileSearch): Observable<number> {
		if (this.ifTokenNotExpired()) {
			if (this.myCookieService.token) {
				return this.http.post(StaticUrls._bloccoImmobileCountSearchEffettuati, JSON.stringify(blocco), this.options)
					.map(counter => { return counter.json(); })
					.catch(this.handleError);
			}
		}
	}

	searchRicevuti(blocco: BloccoImmobileSearch): Observable<Array<BloccoImmobile>> {
		if (this.ifTokenNotExpired()) {
			if (this.myCookieService.token) {
				return this.http.post(StaticUrls._bloccoImmobileSearchRicevuti, JSON.stringify(blocco), this.options)
				.map(this.extractData)
				.catch(this.handleError);
			}
		}
	}

	countSearchRicevuti(blocco: BloccoImmobileSearch): Observable<number> {
		if (this.ifTokenNotExpired()) {
			if (this.myCookieService.token) {
				return this.http.post(StaticUrls._bloccoImmobileCountSearchRicevuti, JSON.stringify(blocco), this.options)
					.map(counter => { return counter.json(); })
					.catch(this.handleError); 
			}
		}
	}

	countSearchRicevutiInAttesa(): Observable<number> {
		if (this.ifTokenNotExpired()) {
			if (this.myCookieService.token) {
				return this.http.post(StaticUrls._bloccoImmobileCountSearchRicevutiInAttesa, {}, this.options)
					.map(counter => { return counter.json(); })
					.catch(this.handleError); 
			}
		}
	}

	private extractData(res: Response) {
		this.blocchi = res.json();
		return this.blocchi;
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
			if (error.status == 401) {
				this.router.navigate(['login']);
			}
		}
		else {
			errMsg = error.message ? error.message : error.toString();
		}
		return Observable.throw(errMsg);
	}

	private ifTokenNotExpired() {
		if (this.myCookieService.token) {
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			}
			else {
				return true;
			}
		}
		else {
			return false;
		}
	}
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/blocco-immobile.service.ts